<template>
  <main class="content-container">
    <h3>For all inquiries, please email Mark Daniel at <a href="mailto:markjdaniel50@gmail.com">markjdaniel50@gmail.com</a></h3>
  </main>
</template>
